import "./Controls"
import ImageSetting from "./control components/ImageSetting"
import MoveSetting from "./control components/MoveSetting"
import ColorSetting from "./control components/ColorSetting"
import { useSelector } from "react-redux"


const Controls = () => {

    const setting = useSelector( state => state.setting)

    const hanldeSettingChange = (setting) => {
        switch(setting){
            case "color":
                return <ColorSetting/>
            case "move":
                return <MoveSetting/>
            case "image":
                return <ImageSetting/>
            default:
                return ""
        }
    }

    return(
        <div className="Controls">
            {
                hanldeSettingChange(setting)
            }
        </div>
    )
}

export default Controls